/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/* eslint-disable no-use-before-define */
import React, { useState, useCallback, useEffect } from "react";
import Cropper from "react-easy-crop";
import { Modal, Button, Slider, Checkbox } from "antd";
import getCroppedImg from "./cropImageHelper"; // Helper function to get the cropped image

const CROP_WIDTH = 186; // Width from your PDF layout
const CROP_HEIGHT = 225; // Height from your PDF layout

const ImageCropper = ({ visible, imageSrc, busy = false, onClose, onSave, showIDPrint = false, onPrintSample }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [reprocessAI, setReprocessAI] = useState(true);
  const [cropPixels, setCropPixels] = useState(null);

  const onCropComplete = useCallback((_, areaPixels) => {
    setCropPixels(areaPixels);
  }, [reprocessAI]);

  const handleSave = async () => {
    if (!cropPixels) return;
    const croppedImage = await getCroppedImg(imageSrc, cropPixels);
    onSave(croppedImage, reprocessAI); // Pass cropped image to parent component
    // handleClose(); // Reset state after saving
  };

  const handlePrintSample = async () => {
    if (!cropPixels) return;
    const croppedImage = await getCroppedImg(imageSrc, cropPixels);
    if (onPrintSample) onPrintSample(croppedImage); // Pass cropped image to parent component
    // handleClose(); // Reset state after saving
  };

  const handleClose = () => {
    setReprocessAI(true)
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCropPixels(null);
    onClose(); // Ensure the modal is closed properly
  };

  // Reset crop state when modal opens
  useEffect(() => {
    if (visible) {
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setCropPixels(null);
    }
  }, [visible]);

  // Smooth Mouse Wheel Zoom
  const handleWheelZoom = (event) => {
    event.preventDefault();
    setZoom((prevZoom) => {
      const zoomChange = event.deltaY * -0.0015; // Adjusted sensitivity for smoothness
      // const newZoom = Math.max(0.2, Math.min(2, prevZoom + zoomChange)); // Keep within range
      const newZoom = Math.max(0.05, Math.min(3, prevZoom + zoomChange)); // Keep within range
      return newZoom;
    });
  };

  return (
    <Modal
      open={visible}
      footer={null}
      onCancel={handleClose}
      centered
      title="Crop & Resize Image"
      destroyOnClose
    >
      <div
        style={{ position: "relative", width: "100%", height: 300, background: "#f5f5f5" }}
        onWheel={handleWheelZoom} // Enable smooth mouse wheel zoom
      >
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={CROP_WIDTH / CROP_HEIGHT} // Maintains the fixed aspect ratio
          cropSize={{ width: CROP_WIDTH, height: CROP_HEIGHT }}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
        />
      </div>
      <div style={{ marginTop: 10 }}>
        <span>Zoom</span>
        <Slider
          min={0.2} // Allow zooming out to 20%
          max={3}   // Reduced max zoom for better control
          step={0.005} // Super smooth zoom changes
          value={zoom}
          onChange={setZoom}
        />
      </div>
      <div className="flex flex-col">
        <Checkbox checked={reprocessAI} onClick={(event) => {
          event.preventDefault();
          setReprocessAI(!reprocessAI)
        }}>Reprocess AI ?</Checkbox>
        <div style={{ textAlign: "right", marginTop: 10 }} className="space-x-2">
          <Button onClick={handleClose} disabled={busy}>Cancel</Button>
          <Button type="primary" onClick={handleSave} disabled={busy}>Save</Button>
          {showIDPrint && <Button type="primary" onClick={handlePrintSample} disabled={busy}>Print Sample</Button>}
        </div>
      </div>
    </Modal>
  );
};

export default ImageCropper;
